import { SafeAny } from '@core/types/safe-any.type';
import { Chart } from 'chart.js';

export const lineShadowPlugin = {
  id: 'lineShadowPlugin',
  beforeDatasetsDraw(chart: Chart) {
    const ctx = chart.ctx;

    chart.data.datasets.forEach((dataset: SafeAny, index: number) => {
      const meta = chart.getDatasetMeta(index);
      if (!meta?.dataset) return;

      const datasetElement = meta.dataset as SafeAny;

      if (datasetElement._originalDraw) {
        datasetElement.draw = datasetElement._originalDraw;
      }

      datasetElement._originalDraw = datasetElement.draw;

      datasetElement.draw = function (...args: SafeAny[]) {
        ctx.save();
        ctx.shadowColor = dataset.borderShadowColor || '#2DA470B2';
        ctx.shadowBlur = 30;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 4;
        this._originalDraw(...args);
        ctx.restore();
      };
    });
  },
};
